import React from 'react';
import { useSelectSubAreaFieldQuery } from 'generated/graphql';

export type IData = {
  id: string;
  name: string;
  displayName: string;
};

export function useQuery() {
  const tuple = useSelectSubAreaFieldQuery();

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.subAreas?.map((node) => ({
        id: node?.id ?? '',
        name: node?.name ?? '',
        displayName: node?.displayName ?? ''
      }
      )) ?? [];

      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
